import { Logger } from 'data/common';
import { fromJS, Map } from 'immutable';

let environment = '';

function debug(eventName, params) {
    Logger.debug(`${environment} : <---------- Event Received ${eventName}`, params);
}

function bindSettingsEvents(ProductInstance) {
    ProductInstance.socketOn('inelioSlaveMeasures', function (args) {
        debug(ProductInstance.environment, 'inelioSlaveMeasures', args);
        ProductInstance.emit('getInelioSlaveMeasures', args);
    });

    ProductInstance.socketOn('inelioStageMeasures', function (args) {
        debug(ProductInstance.environment, 'inelioStageMeasures', args);
        ProductInstance.emit('getInelioStageMeasures', args);
    });

    ProductInstance.socketOn('inelioActiveAlarms', function(args) {
        debug(ProductInstance.environment, 'inelioActiveAlarms', args);
        ProductInstance.emit('getInelioActiveAlarms', args);
    });

    ProductInstance.socketOn('inelioStageActuators', function(args) {
        debug(ProductInstance.environment, 'inelioStageActuators', args);
        ProductInstance.emit('getInelioStageActuators', args);
    });

    ProductInstance.socketOn('inelioSlaveActuators', function(args) {
        debug(ProductInstance.environment, 'inelioSlaveActuators', args);
        ProductInstance.emit('getInelioSlaveActuators', args);
    });

    ProductInstance.socketOn('productStatus', function(args) {
        const { fheCenter_mac, product_identifier: productIdentifier, product_type: productType, status } = args;
        debug(ProductInstance.environment, 'productStatus', args);
        if (!status) return false;

        if (fheCenter_mac === undefined || productIdentifier === undefined || productType === undefined)
            return Logger.error(`Arguments manquants sur l'envent socket productStatus : "${args}"`);
        const homeId = ProductInstance.getState().environments[ProductInstance.environment].data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);

        const productKey = `${homeId}_${productType}_${productIdentifier}`;

        const product = ProductInstance.getState().environments[ProductInstance.environment].data.Products.getIn(['list', productKey], new Map());
        const productsInit = ProductInstance.getState().environments[ProductInstance.environment].data.Homes.getIn(
            ['list', homeId.toString(), 'productsInitialized'],
            false,
        );

        if (productsInit && product.size === 0) {
            if (status === 'connected') ProductInstance.emit('newProduct', homeId.toString(), productType, productIdentifier);
        } else {
            ProductInstance.emit(`productStatusChange${fheCenter_mac}`, {
                productMac: productIdentifier,
                productStatus: status,
                productType,
                productKey,
                productLabel: product.getIn(['label'], ''),
                displayType: product.getIn(['type'], ''),
            });

            if (product.size > 0) {
                ProductInstance.dispatch({
                    type: `${ProductInstance.environment.toUpperCase()}__PRODUCT_UPDATE_STATUS`,
                    productKey,
                    status,
                });
            }
        }
    });

    ProductInstance.socketOn('updateProductModuleLabel', function(args) {
        let { fheCenter_mac, product_identifier, product_type, module_type, code, label } = args;
        debug('updateProductModuleLabel', args);
        if (product_type !== 'airzone') code = 0;
        if (
            fheCenter_mac === undefined ||
            product_identifier === undefined ||
            product_type === undefined ||
            module_type === undefined ||
            code === undefined ||
            label === undefined
        )
            return Logger.error(`Arguments manquants sur l'envent socket updateProductModuleLabel : "${args}"`);
        const homeId = ProductInstance.getState().environments[ProductInstance.environment].data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);
        const productKey = `${homeId}_${product_type}_${product_identifier}`;
        const productModuleKey = `${product_type}_${product_identifier}_${code}`;
        if (!ProductInstance.getState().environments[ProductInstance.environment].data.Products.hasIn(['list', productKey]))
            return Logger.debug(`Le produit "${productKey}" n'est pas présent dans le store`);
        if (
            !ProductInstance.getState().environments[ProductInstance.environment].data.Products.hasIn([
                'list',
                productKey,
                'productModules',
                productModuleKey,
            ])
        )
            return Logger.debug(`Le productModule "${productModuleKey}" n'est pas présent dans le store`);
        const form = { label };
        ProductInstance.dispatch({
            type: `${ProductInstance.environment.toUpperCase()}__PRODUCT_MODULE_UPDATE`,
            productKey,
            productModuleKey,
            form,
        });
    });

    ProductInstance.socketOn('updateFheProductThreshold', function(args) {
        let { fheCenter_mac, product_identifier, module_type, thresholds_config } = args;
        debug('updateFheProductThreshold', args);
        if (fheCenter_mac === undefined || product_identifier === undefined || module_type === undefined || thresholds_config === undefined)
            return Logger.error(`Arguments manquants sur l'envent socket updateFheProductThreshold : "${args}"`);
        const homeId = ProductInstance.getState().environments[ProductInstance.environment].data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);
        const productKey = `${homeId}_fhe_product_${product_identifier}`;
        if (!ProductInstance.getState().environments[ProductInstance.environment].data.Products.hasIn(['list', productKey]))
            return Logger.debug(`Le produit "${productKey}" n'est pas présent dans le store`);
        let newThreshold = fromJS(thresholds_config);
        newThreshold.map((value, key) => {
            let productModuleKey = `fhe_product_${product_identifier}_${key}`;
            if (
                !ProductInstance.getState().environments[ProductInstance.environment].data.Products.hasIn([
                    'list',
                    productKey,
                    'productModules',
                    productModuleKey,
                ])
            )
                return Logger.debug(`Le productModule "${productModuleKey}" n'est pas présent dans le store`);
            ProductInstance.dispatch({
                type: `${ProductInstance.environment.toUpperCase()}__FHEPRODUCT_THRESHOLD_UPDATE`,
                productKey,
                productModuleKey: productModuleKey,
                threshold: value,
            });
        });
    });

    ProductInstance.socketOn('updateFheProductGain', function(args) {
        let { fheCenter_mac, product_identifier, module_type, gains_config } = args;
        debug('updateFheProductGain', args);
        if (fheCenter_mac === undefined || product_identifier === undefined || module_type === undefined || gains_config === undefined) {
            return Logger.error(`Arguments manquants sur l'event socket updateFheProductGain : "${args}"`);
        }
        const homeId = ProductInstance.getState().environments[ProductInstance.environment].data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) {
            return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);
        }
        const productKey = `${homeId}_fhe_product_${product_identifier}`;
        if (!ProductInstance.getState().environments[ProductInstance.environment].data.Products.hasIn(['list', productKey])) {
            return Logger.debug(`Le produit "${productKey}" n'est pas présent dans le store`);
        }
        let newGain = fromJS(gains_config);
        newGain.map((value, key) => {
            let productModuleKey = `fhe_product_${product_identifier}_${key}`;
            if (
                !ProductInstance.getState().environments[ProductInstance.environment].data.Products.hasIn([
                    'list',
                    productKey,
                    'productModules',
                    productModuleKey,
                ])
            )
                return Logger.debug(`Le productModule "${productModuleKey}" n'est pas présent dans le store`);
            ProductInstance.dispatch({
                type: `${ProductInstance.environment.toUpperCase()}__FHEPRODUCT_GAIN_UPDATE`,
                productKey,
                productModuleKey: productModuleKey,
                gain: value,
            });
        });
    });

    ProductInstance.socketOn('updateFheProductPolarity', function(args) {
        let { fheCenter_mac, product_identifier, module_type, reverse_polarity_config } = args;
        debug('updateFheProductPolarity', args);
        if (fheCenter_mac === undefined || product_identifier === undefined || module_type === undefined || reverse_polarity_config === undefined)
            return Logger.error(`Arguments manquants sur l'envent socket updateFheProductPolarity : "${args}"`);
        const homeId = ProductInstance.getState().environments[ProductInstance.environment].data.Boxes.getIn(['list', fheCenter_mac, 'homeId'], null);
        if (!homeId) return Logger.debug(`Impossible de retrouver le home id avec la boxe mac ${fheCenter_mac}`);
        const productKey = `${homeId}_fhe_product_${product_identifier}`;
        if (!ProductInstance.getState().environments[ProductInstance.environment].data.Products.hasIn(['list', productKey]))
            return Logger.debug(`Le produit "${productKey}" n'est pas présent dans le store`);
        let newPolarity = fromJS(reverse_polarity_config);
        newPolarity.map((value, key) => {
            let productModuleKey = `fhe_product_${product_identifier}_${key}`;
            if (
                !ProductInstance.getState().environments[ProductInstance.environment].data.Products.hasIn([
                    'list',
                    productKey,
                    'productModules',
                    productModuleKey,
                ])
            )
                return Logger.debug(`Le productModule "${productModuleKey}" n'est pas présent dans le store`);
            ProductInstance.dispatch({
                type: `${ProductInstance.environment.toUpperCase()}__FHEPRODUCT_POLARITY_UPDATE`,
                productKey,
                productModuleKey: productModuleKey,
                polarity: value,
            });
        });
    });
}

export default function initBinds(ProductInstance) {
    environment = ProductInstance.environment;
    bindSettingsEvents(ProductInstance);
}



// WEBPACK FOOTER //
// ./environments/genericEnv/eventsSocket/Product/binds.js